import React from 'react';
import clsx from 'clsx';
import { OptionsAlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { AccountCircle, Cart, Menu } from '@insurancemenu/imenu-components-lib/dist/icons';
import { Button, Dropdown } from '@insurancemenu/imenu-components-lib/dist/components';
import { Link } from 'react-router-dom';
import { createStyles } from './styles';

interface DropdownLinkElementProps {
  href: string;
  text: string;
  icon: JSX.Element;
  classes: ReturnType<typeof createStyles>;
  className?: string;
}
interface DropdownButtonElementProps {
  onClick: () => void;
  text: string;
  classes: ReturnType<typeof createStyles>;
  icon: JSX.Element;
}

export interface MobileDropdownProps {
  cartLink: string;
  isBrowseInfoPage: boolean;
  customMainColor: string;
  contactMeAction: () => void;
}

const DropdownLinkElement: React.FC<DropdownLinkElementProps> = ({ href, text, icon, classes, className = '' }) => {
  return (
    <li className={clsx(classes.mobileDropdownOption, className)}>
      <Link to={href} className={classes.mobileDropdownLink}>
        <span className={classes.mobileDropdownIcon}>{icon}</span>
        <span className={classes.mobileDropdownLinkText}>{text}</span>
      </Link>
    </li>
  );
};

const DropdownButtonElement: React.FC<DropdownButtonElementProps> = ({ text, onClick, icon, classes }) => {
  return (
    <li className={classes.mobileDropdownOption}>
      <Button type="text" leftIconProp={icon} className={classes.mobileDropdownLink} onClick={onClick}>
        {text}
      </Button>
    </li>
  );
};

const MobileDropdown = ({
  cartLink,
  customMainColor,
  isBrowseInfoPage,
  contactMeAction,
}: MobileDropdownProps): JSX.Element => {
  const classes = createStyles({ customMainColor });

  const ContactMeDropdownOption = {
    value: 'contactForm',
    renderFunc: (): JSX.Element => (
      <DropdownButtonElement text="Contact me" icon={<AccountCircle />} onClick={contactMeAction} classes={classes} />
    ),
  };

  const CartDropdownOption = {
    value: '',
    renderFunc: (): JSX.Element => (
      <DropdownLinkElement text="Cart" href={cartLink} icon={<Cart />} classes={classes} className={classes.cartLink} />
    ),
  };

  const MobileDropdownOptions = cartLink ? [ContactMeDropdownOption, CartDropdownOption] : [ContactMeDropdownOption];
  return (
    <>
      {isBrowseInfoPage ? (
        <div className={classes.menuStub} />
      ) : (
        <Dropdown
          name="mobileNavDropdown"
          options={MobileDropdownOptions}
          optionsAlignment={OptionsAlignmentTypes.BOTTOM_LEFT}
          optionsWidth="16rem"
          closedElement={
            <button
              type="button"
              aria-label="Menu"
              className={clsx(classes.mobileDropdownButton, classes.mobileDropdownButtonClosed)}
            >
              <Menu height="3.2rem" width="3.2rem" />
            </button>
          }
          openedElement={
            <button
              type="button"
              aria-label="Menu"
              className={clsx(classes.mobileDropdownButton, classes.mobileDropdownButtonOpened)}
            >
              <Menu height="3.2rem" width="3.2rem" />
            </button>
          }
        />
      )}
    </>
  );
};

export default MobileDropdown;
